import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MDBox from "components/MDBox";
import MDAvatar from "components/MDAvatar";
import MDTypography from "components/MDTypography";
import { useNavigate } from "react-router-dom";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const Company = ({ image, name }) => (
  <MDBox display='flex' alignItems='center' lineHeight={1}>
    <MDAvatar src={image} name={name} size='sm' />
    <MDTypography variant='button' fontWeight='medium' ml={1} lineHeight={1}>
      {name}
    </MDTypography>
  </MDBox>
);

export default function TableTopOrder ({ topSellProduct }) {
  const navigate = useNavigate();

  const redirect = data => {
    navigate("/product-details", { state: { productId: data.productId } });
  };
  return (
    <TableContainer component={Paper}>
      <Table aria-label='customized table'>
        <TableBody>
          <TableRow>
            <StyledTableCell
              width='60%'
              style={{
                fontWeight: 700,
                textTransform: "uppercase",
                color: "#344767",
                whiteSpace: "nowrap",
              }}
            >
              Product
            </StyledTableCell>
            <StyledTableCell
              width='20%'
              style={{
                fontWeight: 700,
                textTransform: "uppercase",
                color: "#344767",
                whiteSpace: "nowrap",
              }}
            >
              No of Order
            </StyledTableCell>
            <StyledTableCell
              width='20%'
              style={{
                fontWeight: 700,
                textTransform: "uppercase",
                color: "#344767",
                whiteSpace: "nowrap",
              }}
            >
              Price
            </StyledTableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          {topSellProduct?.length == 0 && <div style={{ padding: "0 16px 10px", fontSize: "14px" }}>No Top Selling Products Yet!</div>}
          {topSellProduct?.length > 0 &&
            topSellProduct?.map(row => (
              <StyledTableRow key={row.name}>
                <StyledTableCell
                  component='th'
                  scope='row'
                  onClick={() => redirect(row)}
                  style={{ cursor: "pointer" }}
                >
                  <Company image={row?.product?.image} name={row?.product?.nameEn} />
                </StyledTableCell>
                <StyledTableCell>{row?.totalOrders}</StyledTableCell>
                <StyledTableCell style={{ fontWeight: "400" }}>
                  ₴{row?.product?.discountPrice}
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
